module.exports = __webpack_public_path__ + "static/media/n_icon_jiaoyimingxi@2x.2113e4c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_jiaoyimingxi@2x.png
// module id = 1807
// module chunks = 0 1